<script setup>
import { useHrefLang } from '~/composables/seo/hreflang'
import { useAnchorTitle } from '~/composables/useAnchorTitle'
import { useSearchStore } from '~/stores/search'
import { slugifyString } from '~/utils/slugify'

const props = defineProps({
  pageObj: {
    type: Object,
    required: true,
  },
})

const { t } = useI18n()

const searchStore = useSearchStore()
const { q } = storeToRefs(searchStore)

const page = toRef(props, 'pageObj')

function displayQ() {
  return `${page?.value?.search?.q} ${q.value}`
}

useHrefLang(page?.value?.meta?.hreflang)

const anchorTitle = computed(() => useAnchorTitle(page?.value?.title))
</script>

<template>
  <div>
    <div
      class="row spacer-navigation"
      :class="{ 'spacer-footer': page?.body.length === 0 }"
    >
      <div class="col-12">
        <h1
          :id="anchorTitle"
          class="scale-6 spacer-40"
        >
          {{ page.title }}
        </h1>
        <h2
          :id="slugifyString(t('magazine.overview.search'))"
          class="scale-1 scale-1--bold-uppercase spacer-25-20"
        >
          {{ t('magazine.overview.search') }}
        </h2>
        <SearchFakeInput
          :q="displayQ()"
          class="spacer-80-60 search-input"
        />
      </div>
    </div>
    <div
      v-if="page?.body.length > 0"
      class="spacer-footer"
    >
      <CmsBody :page="page" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '~/assets/scss/variables.scss';
@import 'bootstrap/scss/mixins';

.search-input {
  width: 66%;

  @include media-breakpoint-down(560) {
    width: 100%;
  }
}
</style>
